import store from '@/store/store.js'

export function widthCheck () {
  if (window.innerWidth < 992) {
    store.state.mobileView = true
  } else {
    store.state.mobileView = false
  }
}

export function widthChange () {
  window.addEventListener('resize', () => {
    if (window.innerWidth < 992) {
      store.state.mobileView = true
    } else {
      store.state.mobileView = false
    }
  })
}
